export default function LinkedInSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.871"
      height="20.833"
      viewBox="0 0 20.871 20.833"
    >
      <path
        data-name="linkedin in brands 2 1"
        d="M4.688,20.833H.369V6.922H4.688ZM2.528,5.028A2.514,2.514,0,1,1,5.038,2.5,2.549,2.549,0,0,1,2.528,5.028Zm18.333,15.8H16.544V14.063c0-1.61-.028-3.684-2.244-3.684-2.244,0-2.585,1.752-2.585,3.57v6.885H7.4V6.922h4.148V8.816H11.6a4.521,4.521,0,0,1,4.091-2.244c4.375,0,5.18,2.879,5.18,6.619Z"
        fill="#0f21d8"
      />
    </svg>
  );
}
